// src/components/About.js
import React, { useState, useEffect } from 'react';
import './About.css';

const images = [
  '/Media/AboutUS/1.png',
  '/Media/AboutUS/2.png',
  '/Media/AboutUS/3.png',
];

const About = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="about-main-container" id="about">
      {/* Container1 */}
      <div className="container1">
        <div className="containerA">
          <h2>YOG YATRA INSTITUTE</h2>
          <h3>”Your Path to Peace, Health & Harmony"</h3>
          <p>
            <i>
            Yog Yatra Institute is your guide to discovering inner calm, balance, and strength.
            We help you build a stable, peaceful center within — a still point in life’s constant motion — that becomes the source of physical health, mental clarity, and joyful living.
            </i>
          </p>
          <p>
            <i>
            Our classes are tailored for all age groups and focus on real-life needs: work-life balance, stress relief, better sleep, improved focus, and enhanced productivity.

            Rooted in the principles of Classical Yoga, we draw from rich traditions like Karma Yoga, Bhakti Yoga, Hatha Yoga, Mantra Yoga, and Laya Yoga, making them practical and relevant in today’s modern world.

            At Yog Yatra Institute, we blend timeless wisdom with modern understanding to create a yoga practice that truly works for you.
            </i>
          </p>
          <p>
            <b><i>Join us, and begin your own Yog Yatra — your journey to peace and well-being.</i></b>
          </p>
        </div>
        <div className="containerB">
          <img
            src={images[currentImage]}
            alt={`about-${currentImage}`}
            className="about-slider-image"
          />
          <div className="dots">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentImage ? 'active' : ''}`}
                onClick={() => setCurrentImage(index)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Container2 */}
      <div className="container2">
        <div className="containerT1 teacher-block">
          <img src="/Media/AboutUS/Teacher/1.jpg" alt="Ashima" className="teacher-image" />
          <div className="teacher-details">
            <h3>Ashima</h3>
            <ul>
              <p><i>Certified Yoga Teacher</i></p>
              <li>RYT 200 hrs – Yoga Alliance</li>
              <li>Master’s in Yoga – UK University</li>
              <li>Diploma in Yoga – LBS, Delhi</li>
              <li>Advanced Certification in Yoga – Morarji Desai, Delhi</li>
              <li>Pre-Natal Yoga – Yoga Alliance</li>
              <li><strong>Experience:</strong> 7+ years of teaching</li>
            </ul>
          </div>
        </div>

        <div className="containerT2 teacher-block">
          <img src="/Media/AboutUS/Teacher/2.jpg" alt="Ashok" className="teacher-image" />
          <div className="teacher-details">
            <h3>Ashok</h3>
            <ul>
              <p><i>Certified Yoga Teacher</i></p>
              <li>RYT 500 hrs – Yoga Alliance</li>
              <li>Master’s in Yoga – UK University</li>
              <li>Diploma in Yoga – LBS, Delhi</li>
              <li>Advanced Certification in Yoga – Morarji Desai, Delhi</li>
              <li><strong>Experience:</strong> 7+ years of teaching</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;